import { Component, OnInit } from '@angular/core';
import { CambioViaPagoPensionService } from '../../core/services/cambio-via-pago-pension.service';
import { ROUTING_CAMBIO_VIA_PAGO_PENSION } from '@constants/url.constant';
import { ActivatedRoute, Router } from '@angular/router';
import { StorageService } from '@services/storage/storage.service';
import { BASIC_CLIENT_INFO } from '@constants/data-service.constant';
import { CAMBIO_VIA_PAGO_DATOS_PERSONALES_ERROR } from '@constants/cambio-via-pago-properties.constants';
import { GenericErrorOps } from '@shared/components/generic-error/interfaces/generic-error-ops.interface';
import { WHATSAPP_URL } from '@constants/business.constant';

@Component({
    selector: 'app-cambio-via-pago-home',
    templateUrl: 'cambio-via-pago-home.component.html',
    styleUrls: ['cambio-via-pago-home.component.scss'],
    standalone: false
})
export class CambioViaPagoHomeComponent implements OnInit {
  public loading: boolean = false;
  public error: boolean = false;
  public enableButtonRetry: boolean = false;
  public errorOps: GenericErrorOps;

  constructor(
    private readonly service: CambioViaPagoPensionService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly storageService: StorageService
  ) {}

  ngOnInit(): void {
    void this.initData();
  }


  private async initData() {
    try {
      await this.service.storeToken();
    } catch (error) {
      console.error('Error al guardar token', error);
    }
  }

  async iniciarCambioViaPago() {
      this.loading = true;
      const clientInfo = await this.storageService.get(BASIC_CLIENT_INFO);
      const { email, cellphoneNumber } = clientInfo;
      if(email || cellphoneNumber){
        this.router.navigate([`../${ROUTING_CAMBIO_VIA_PAGO_PENSION.CAMBIO_VIA_PAGO}`], {
          relativeTo: this.activatedRoute,
        });
      }else{
        this.errorOps = CAMBIO_VIA_PAGO_DATOS_PERSONALES_ERROR;
        this.error = true;
        this.enableButtonRetry = true;
      }
      this.loading = false;
  }

  async onRetryEvent() {
    const urlWhatsApp = WHATSAPP_URL;
    window.open(urlWhatsApp, '_blank');
  }

  onGoToEvent() {
    this.error = false;
    this.enableButtonRetry = false;
  }

}
